// @flow

// type BringBackTo = {
//   bringBackTo: ?'simReplacement' | 'confirmPlan' | 'confirmPlanDuringActivate',
// };

// | {|
//     type: 'SIGNUP_REFRESH_PAYMENT_DURING_ORDER_SIM',
//   |}
// | {|
//     type: 'SIGNUP_REFRESH_PAYMENT_DURING_ACTIVATE',
//   |}

export type VoucherActionType =
  | {| type: 'FETCH_AVAILABLE_VOUCHERS' |}
  | {| type: 'SET_CURRENT_VOUCHER_DETAILS' |}
  | {| type: 'SET_VOUCHER_DETAILS_COME_FROM' |};

export const fetchAvailableVouchers = (): VoucherActionType => ({
  type: 'FETCH_AVAILABLE_VOUCHERS',
});

export const fetchAvailableVouchersSuccess = (availabeVouchers: Object[]): VoucherActionType => ({
  type: 'FETCH_AVAILABLE_VOUCHERS_SUCCESS',
  availabeVouchers,
});

export const setCurrentVoucherDetails = (currentVoucherDetails: Object): VoucherActionType => ({
  type: 'SET_CURRENT_VOUCHER_DETAILS',
  currentVoucherDetails,
});

export const setVoucherDetailsComeFrom = (comeFrom: string): VoucherActionType => ({
  type: 'SET_VOUCHER_DETAILS_COME_FROM',
  comeFrom,
});
